<template>
    <span :title="calendar">{{result}}</span>
</template>

<script>
import moment from 'moment';

export default {
    name: 'Datetime',
    props: { date: String },
    computed: {
        datetime() {
            return moment(this.date);
        },
        calendar() {
            return this.datetime.format('MMMM Do YYYY, h:mm:ss a');
        },
        result() {
            const date = this.datetime;
            const diff = moment().diff(date, 'days');
            if (diff < 1) {
                return date.fromNow();
            }
            return date.calendar();
        },
    },
};
</script>
